import gql from 'graphql-tag';

export const AccountGeolocation = gql(`
  query AccountGeolocation {
    accountGeolocation {
      country {
        iso_code
        is_gdpr
      }
    }
  }
`);
